import React, { useEffect, useState } from "react";
import { Button, Empty, Message, Table, Tag } from "@arco-design/web-react";
import { IconPlus } from "@arco-design/web-react/icon";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import Content from "../Layout/Content";
import LoadingState from "../Layout/LoadingState";
import SummaryCard from "../Layout/SummaryCard";
import SimpleBreadcrumbs from "../Components/Breadcrumbs/SimpleBreadcrumbs";
import { FetchApi, PostApi } from "../Api/AuthenticatedApi";
import SequenceDialog from "./SequenceDialog";
import { sequenceStatusMeta, sequenceTriggerLabel } from "./sequenceMeta";

const Toolbar = styled.div`
  display: flex;
  justify-content: flex-end;
  min-height: 56px;
  padding: 0 8px;
  align-items: center;
`;

export default function Sequences() {
  const navigate = useNavigate();
  const { getAccessTokenSilently } = useAuth0();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(false);

  useEffect(() => {
    FetchApi(
      getAccessTokenSilently,
      "/api/sequences/",
      (data) => {
        setLoading(false);
        setRows(Array.isArray(data) ? data : []);
      },
      () => navigate("/login"),
      () => {
        setLoading(false);
        Message.error("Failed to load sequences");
      }
    );
  }, [getAccessTokenSilently, navigate, reload]);

  const handleCreate = (record) => {
    PostApi(
      getAccessTokenSilently,
      "/api/sequences/",
      (created) => {
        Message.success("Sequence created");
        if (created && created.id) {
          navigate(`/sequences/${created.id}/edit`);
        } else {
          setReload((r) => !r);
        }
      },
      () => navigate("/login"),
      (err) => Message.error((err && err.message) || "Failed to create sequence"),
      record
    );
  };

  if (loading) {
    return <LoadingState />;
  }

  const columns = [
    { title: "Name", dataIndex: "name" },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => {
        const meta = sequenceStatusMeta(status);
        return <Tag color={meta.color}>{meta.label}</Tag>;
      },
    },
    {
      title: "Trigger",
      dataIndex: "trigger_type",
      render: (t) => sequenceTriggerLabel(t),
    },
  ];

  return (
    <Content>
      <SimpleBreadcrumbs elements={[{ name: "Sequences" }]} />
      <Toolbar>
        <SequenceDialog
          onSave={handleCreate}
          render={(open) => (
            <Button type="primary" icon={<IconPlus />} onClick={open}>
              New Sequence
            </Button>
          )}
        />
      </Toolbar>
      <SummaryCard title="Sequences" subTitle="Automated multi-step email journeys">
        <Table
          size="small"
          rowKey="id"
          columns={columns}
          data={rows}
          pagination={false}
          noDataElement={
            <Empty description="No sequences yet">
              <SequenceDialog
                onSave={handleCreate}
                render={(open) => (
                  <Button type="primary" style={{ marginTop: 12 }} onClick={open}>
                    Create your first sequence
                  </Button>
                )}
              />
            </Empty>
          }
          onRow={(row) => ({
            style: { cursor: "pointer" },
            onClick: () => navigate(`/sequences/${row.id}/edit`),
          })}
        />
      </SummaryCard>
    </Content>
  );
}
